import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { SingleImageCard } from '../../../lib/components/card/single_image_card'
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'
import { actions as modalActions } from '../../../redux/ducks/modal'
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const WKEY = 'TEST';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class TestView extends Component {

  componentDidMount() {
    const _props = this.props
    _props.wSetEnv({
      type: "params",
      env: "outlet",
      value: { "outlet": "test123" }
    });
    const dit = {
      domain: "test", isTenant: true
    };
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...dit, url: "http://www.example.com", usingAuth: false },
        wcallback: {
          started: function (id) {

          },
          finished: function (id, result) {
          }
        },
        wenv: { params: "outlet" },
        wreducer: {
          enable: false
        }
      }
    );
    _props.wSetConfig({
      background_config: {
        "1": {
          wparam: { ...dit, url: 'http://www.example.com/' }
        },
        "2": {
          wparam: { ...dit, url: 'http://www.example.com/' }
        },
        "3": {
          wparam: { ...dit, url: 'http://www.example.com/' }
        },
        "4": {
          wparam: { ...dit, url: 'http://www.example.com/' }
        },
        "5": {
          wparam: { ...dit, url: 'http://www.example.com/' }
        }
      },
      single_config: {
        "10": {
          wparam: { ...dit, url: 'http://www.example.com' },
          wcallback: {
            finished: (id, result) => {
              this.props.showSingleNotification({ message: "Sukses" });
              this.props.openSingleModal();
            }
          },
          wenv: { params: "outlet" }
        }
      }
    });
  }

  componentWillUnmount() {
    const _props = this.props
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  click() {
    this.props.wUnsetEnv({
      type: "params",
      env: "outlet",
      value: { "outlet": "test456" }
    });
  }

  click2() {
    this.props.wUnsetEnv({
      type: 'param',
      env: "outlet"
    });
  }

  render() {
    return (
      <div>
        <div style={{ width: "320px" }}>
          <SingleImageCard></SingleImageCard>
        </div>
        <Button onClick={
          () => { this.click() }
        }>
          Button 1
            </Button>
        <Button onClick={
          () => { this.click2() }
        }>
          Button 2
         </Button>
        <Button>
          Button 3
      </Button>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    // items: state.webservice.results,
    // error: state.webservice.error
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    dispatch,
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
    ...bindActionCreators(modalActions, dispatch),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TestView));
